<div class="modal-header text-center d-block">
	<h4 class="modal-title d-inline-block">Meilleurs plannings</h4>
	<button
		type="button"
		class="btn-close close pull-right"
		aria-label="Close"
		(click)="modalRefTmpOptimReports?.hide()"
	>
		<span aria-hidden="true" class="visually-hidden">&times;</span>
	</button>
</div>
<div class="modal-body">
	<table
		class="table table-sm text-center table-hover table-striped table-light align-middle"
	>
		<caption>
			Rapport de planification
		</caption>
		<thead>
			<tr>
				<th
					scope="col"
					class="fs-small hand-cursor"
					(click)="sortChange('travel distance')"
				>
					Distance (km)
					<span
						*ngIf="sortType === 'travel distance' && sortOrder === 'asc'"
						class="bi bi-caret-up-fill"
					></span>
					<span
						*ngIf="sortType === 'travel distance' && sortOrder === 'desc'"
						class="bi bi-caret-down-fill"
					></span>
				</th>
				<th
					scope="col"
					class="fs-small hand-cursor"
					(click)="sortChange('working time')"
				>
					Temps travail (hh:mm)
					<span
						*ngIf="sortType === 'working time' && sortOrder === 'asc'"
						class="bi bi-caret-up-fill"
					></span>
					<span
						*ngIf="sortType === 'working time' && sortOrder === 'desc'"
						class="bi bi-caret-down-fill"
					></span>
				</th>
				<th
					scope="col"
					class="fs-small hand-cursor"
					(click)="sortChange('travel time')"
				>
					Temps trajet (hh:mm)
					<span
						*ngIf="sortType === 'travel time' && sortOrder === 'asc'"
						class="bi bi-caret-up-fill"
					></span>
					<span
						*ngIf="sortType === 'travel time' && sortOrder === 'desc'"
						class="bi bi-caret-down-fill"
					></span>
				</th>
				<th
					scope="col"
					class="fs-small hand-cursor"
					(click)="sortChange('waiting time')"
					*ngIf="isDisplayMoreInfoButtonClicked"
				>
					Temps d'attente (hh:mm)
					<span
						*ngIf="sortType === 'waiting time' && sortOrder === 'asc'"
						class="bi bi-caret-up-fill"
					></span>
					<span
						*ngIf="sortType === 'waiting time' && sortOrder === 'desc'"
						class="bi bi-caret-down-fill"
					></span>
				</th>
				<th
					scope="col"
					class="fs-small hand-cursor"
					(click)="sortChange('payable waiting time')"
				>
					Attente rémunéré (hh:mm)
					<span
						*ngIf="sortType === 'payable waiting time' && sortOrder === 'asc'"
						class="bi bi-caret-up-fill"
					></span>
					<span
						*ngIf="sortType === 'payable waiting time' && sortOrder === 'desc'"
						class="bi bi-caret-down-fill"
					></span>
				</th>
				<th
					scope="col"
					class="fs-small hand-cursor"
					(click)="sortChange('TW late arrival time')"
				>
					Retard cumulé (hh:mm)
					<span
						*ngIf="sortType === 'TW late arrival time' && sortOrder === 'asc'"
						class="bi bi-caret-up-fill"
					></span>
					<span
						*ngIf="sortType === 'TW late arrival time' && sortOrder === 'desc'"
						class="bi bi-caret-down-fill"
					></span>
				</th>
				<th
					scope="col"
					class="fs-small hand-cursor"
					(click)="sortChange('extra working time')"
				>
					Heures + (hh:mm)
					<span
						*ngIf="sortType === 'extra working time' && sortOrder === 'asc'"
						class="bi bi-caret-up-fill"
					></span>
					<span
						*ngIf="sortType === 'extra working time' && sortOrder === 'desc'"
						class="bi bi-caret-down-fill"
					></span>
				</th>
				<th
					scope="col"
					class="fs-small hand-cursor"
					(click)="sortChange('not used working time')"
				>
					Heures - (hh:mm)
					<span
						*ngIf="sortType === 'not used working time' && sortOrder === 'asc'"
						class="bi bi-caret-up-fill"
					></span>
					<span
						*ngIf="sortType === 'not used working time' && sortOrder === 'desc'"
						class="bi bi-caret-down-fill"
					></span>
				</th>
				<th
					scope="col"
					class="fs-small hand-cursor"
					(click)="sortChange('Nbr_ satisfaied specialties')"
				>
					Spécialités Satisfaites
					<span
						*ngIf="
							sortType === 'Nbr_ satisfaied specialties' && sortOrder === 'asc'
						"
						class="bi bi-caret-up-fill"
					></span>
					<span
						*ngIf="
							sortType === 'Nbr_ satisfaied specialties' && sortOrder === 'desc'
						"
						class="bi bi-caret-down-fill"
					></span>
				</th>
				<th
					scope="col"
					class="fs-small hand-cursor"
					*ngIf="isDisplayMoreInfoButtonClicked"
					(click)="sortChange('Nbr_ respected preferences')"
				>
					Préférences respectées
					<span
						*ngIf="
							sortType === 'Nbr_ respected preferences' && sortOrder === 'asc'
						"
						class="bi bi-caret-up-fill"
					></span>
					<span
						*ngIf="
							sortType === 'Nbr_ respected preferences' && sortOrder === 'desc'
						"
						class="bi bi-caret-down-fill"
					></span>
				</th>
				<th
					scope="col"
					class="fs-small hand-cursor"
					*ngIf="isDisplayMoreInfoButtonClicked"
					(click)="sortChange('Nbr_ assigned missions')"
				>
					Prestations assignées
					<span
						*ngIf="sortType === 'Nbr_ assigned missions' && sortOrder === 'asc'"
						class="bi bi-caret-up-fill"
					></span>
					<span
						*ngIf="
							sortType === 'Nbr_ assigned missions' && sortOrder === 'desc'
						"
						class="bi bi-caret-down-fill"
					></span>
				</th>
				<th
					scope="col"
					class="fs-small hand-cursor"
					*ngIf="isDisplayMoreInfoButtonClicked"
					(click)="sortChange('Nbr. intervenants')"
				>
					Nb. intervenants
					<span
						*ngIf="sortType === 'Nbr. intervenants' && sortOrder === 'asc'"
						class="bi bi-caret-up-fill"
					></span>
					<span
						*ngIf="sortType === 'Nbr. intervenants' && sortOrder === 'desc'"
						class="bi bi-caret-down-fill"
					></span>
				</th>
				<th scope="col" class="fs-small">Choix</th>
			</tr>
		</thead>
		<tbody>
			<tr
				*ngFor="
					let tmpOptimReport of tmpOptimReports
						| orderByReport: sortType:sortOrder;
					let i = index
				"
				class="hand-cursor"
				(click)="selectOptimReport(tmpOptimReport.id)"
				[ngClass]="{
					'table-active table-primary':
						this.selectedOptimReportId === tmpOptimReport.id
				}"
			>
				<td
					*ngFor="
						let report of tmpOptimReport.report.criteriaReports;
						let j = index
					"
					[hidden]="
						(j > 9 || !isDisplayedSpecifiedCriteria(report.label)) &&
						!isDisplayMoreInfoButtonClicked
					"
				>
					<span
						*ngIf="j < 10 || isDisplayMoreInfoButtonClicked"
						[ngClass]="{
							'text-success fw-bold':
								report.finalValue === '00h00m' || report.bestValue
						}"
					>
						{{
							j >= 9
								? report.finalValue.slice(0, -2)
								: report.finalValue.replace('h', ':').replace('m', '')
						}}
					</span>
				</td>
				<th scope="row">
					<div class="d-grid gap-1 justify-content-end">
						<div class="form-check form-check-reverse">
							<input
								class="form-check-input"
								type="radio"
								name="flexRadioDefault"
								id="'flexRadioDefault_'+j"
								[checked]="this.selectedOptimReportId === tmpOptimReport.id"
								[ngClass]="{
									'theme-main-color-check':
										this.selectedOptimReportId === tmpOptimReport.id
								}"
							/>
						</div>
					</div>
				</th>
			</tr>
		</tbody>
	</table>
	<button
		type="button"
		class="btn theme-main-color-button"
		(click)="displayAdditionalInfo()"
	>
		{{ displayAdditionalInfoButtonLabel }}
	</button>
</div>
<div class="modal-footer">
	<button
		type="button"
		class="btn theme-main-color-button mx-2"
		(click)="modalRefTmpOptimReports?.hide()"
	>
		Retour
	</button>
	<button
		[disabled]="!this.selectedOptimReportId || isBtnValidateChoiceClicked"
		class="col-2 btn btn theme-green-button"
		(click)="makeOptimReportChoice()"
	>
		Valider
	</button>
</div>
